export const ValueSetter = (isSingle, element) => {
  return !isSingle ? element?.ItemValue : element?.ItemContent;
};
